<template>

  <div class="bg-gray-200 min-h-screen relative pb-12">

      <NavbarComponent />

      <main class="flex-grow pt-16">

        <div class="mx-auto pl-20 pr-20 pt-20 pb-10 text-center">
          <font-awesome-icon :icon="['fas', 'circle-exclamation']" class="pb-5 text-6xl text-red-700"/>
          <div class="text-lg md:text-2xl">¡Atención!</div>
            <div class="text-lg md:text-2xl">La página no fue encontrada</div>
          </div>
          <div class="mx-auto text-center pb-20">
          <router-link to="/empresa" class="px-4 py-2 text-center text-black border border-black rounded hover:bg-black hover:text-white transition uppercase">
            <font-awesome-icon :icon="['fas', 'house']" class="mr-2" />
            Volver al home
          </router-link>
        </div>
      </main>

  </div>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavbarComponent from "@/components/commons/NavbarComponent.vue";

export default defineComponent({
  components: {
    NavbarComponent
  },
});
</script>